module.exports = __webpack_public_path__ + "static/media/prepaid recharge.328df757.png";